import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import PropTypes from 'prop-types';
import React from 'react';
import css from './ProductItems.module.scss';
import ProductItem from './ProductItem';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var ProductItems = function ProductItems(_ref) {
  var fabric = _ref.fabric,
      items = _ref.items,
      title = _ref.title;
  return /*#__PURE__*/_jsxs("section", {
    className: css.root,
    children: [/*#__PURE__*/_jsx("h2", {
      className: css.title,
      children: title
    }), /*#__PURE__*/_jsx("ul", {
      className: css.items,
      children: items.map(function (item, index) {
        return /*#__PURE__*/_jsx(ProductItem, _objectSpread(_objectSpread({}, item), {}, {
          fabric: fabric,
          imageLeft: index % 2 === 0
        }), item.id);
      })
    })]
  });
};

ProductItems.propTypes = {
  fabric: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape(_objectSpread({}, ProductItem.propTypes))).isRequired,
  title: PropTypes.string.isRequired
};
export default ProductItems;